const e=async(e,t,n,r,i)=>{let{data:a}=await e.patch(`/webhooks/${t}/${n}/${r}`,{endpoint:i});return a};export{e as updateWebhook};
//# sourceMappingURL=update-webhook.mjs.map